module.exports = __webpack_public_path__ + "img/dragon.8e5991f1.svg";